// Owns which dialog is open, and offers screens the functions to open one (see ../ui/dialogs.ts).

import { useMemo, useState, type ReactNode } from 'react';
import { DialogsContext, type ConfirmOptions, type Dialogs, type RequestDialogOptions } from '../ui/dialogs';
import { ConfirmDialog } from './ConfirmDialog';
import { RequestDetail } from './RequestDetail';
import { RequestDialog } from './RequestDialog';

interface Question {
  options: ConfirmOptions;
  answer: (confirmed: boolean) => void;
}

export function DialogsProvider({ children }: { children: ReactNode }) {
  const [request, setRequest] = useState<RequestDialogOptions | null>(null);
  const [detailId, setDetailId] = useState<string | null>(null);
  const [question, setQuestion] = useState<Question | null>(null);

  const dialogs = useMemo<Dialogs>(
    () => ({
      openRequest: (options = {}) => setRequest(options),
      openDetail: setDetailId,
      confirm: (options) => new Promise((resolve) => setQuestion({ options, answer: resolve })),
    }),
    [],
  );

  const answer = (confirmed: boolean) => {
    question?.answer(confirmed);
    setQuestion(null);
  };

  return (
    <DialogsContext value={dialogs}>
      {children}
      {request && <RequestDialog date={request.date} userId={request.userId} onClose={() => setRequest(null)} />}
      {detailId && <RequestDetail id={detailId} onClose={() => setDetailId(null)} />}
      {question && <ConfirmDialog {...question.options} onAnswer={answer} />}
    </DialogsContext>
  );
}
